<template>
  <div class="exam-rules-container">
    <!-- 内容区域 -->
    <el-card class="rules-card">
      <h2 class="title">考试须知</h2>
      <ol class="rules-list">
        <li>考生须同时持有本人准考证和身份证件于开考前10分钟入场，对号入座，入场后将身份证和准考证放在课桌左上角，便于监考人员查对。</li>
        <li>考生参加考试，只能使用必需的书写文具，如钢笔、铅笔、橡皮等物品。禁止携带书籍、笔记资料、电子设备和与考试无关的物品进入考场。</li>
        <li>开考15分钟后，考生不得入场。开考30分钟后，考生才能交卷出场。考生离场后不得再次进场答卷。</li>
        <li>考场内不得私自借用文具，不许自备草稿纸，不得使用手机、携机或手提电脑等通讯工具，违者作违纪处理。</li>
        <li>考生若遇试题字迹不清，可举手询问，但不得要求监考人员对题意做任何解释或提示。</li>
        <li>考生必须严格遵守考场纪律，考试时不得交头接耳、左顾右盼、抄袭他人试卷、做笔记或与他人进行交流，违者作作弊处理，一律取消考试成绩。</li>
        <li>考生离开考场的次序为监考人员指示为准。违反者无效处理。取得考试资格者视作放弃本次考试。</li>
        <li>考生应自觉服从监考人员管理，不得以任何理由妨碍监考人员进行正常工作。监考人员有权对考场内发生的违规事件进行处理。</li>
      </ol>
      <div class="button-container">
        <!-- <el-button @click="updateAnswerDialog = true;" type="primary" size="large">获取云端记录</el-button> -->
        <el-button type="primary" size="large" @click="startExam" :disabled="isFirstVisit && countdown > 0">
          {{ isFirstVisit && countdown > 0 ? `点击进入考试 倒计时 ${countdown} 秒` : "点击进入考试" }}
        </el-button>
      </div>
    </el-card>
  </div>
  <el-dialog v-model="updateAnswerDialog" title="获取云端记录" width="40%" align-center>
    <span>请问您是否要获取最新的云端临时记录？</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="updateAnswerDialog = false">取消</el-button>
        <el-button type="primary" @click="getTempSubmitSelect">
          确认
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>
  
<script>
import { ElButton, ElCard, ElMessage, ElDialog } from "element-plus";
import { mapGetters } from 'vuex';
import api from '@/utils/api';

export default {
  name: 'ExaminfoCard',
  components: {
    ElCard,
    ElButton,
    ElDialog
  },
  data() {
    return {
      countdown: 15, // 倒计时时间
      examId: -1,
      userInfo: null,
      updateAnswerDialog: false
    };
  },
  methods: {
    async getTempSubmitSelect() {
      try {
        const res = await api.getTempSubmitSelect(this.userInfo.uid, this.joined_exam.examid);
        if (res.code == "0") {
          const answers = res.data;
          if (answers) {
            localStorage.setItem('answers', answers);
            ElMessage.success("成功获取临时记录");
          } else {
            ElMessage.error("云端无临时记录");
          }
        } else {
          ElMessage.error("获取临时记录失败");
        }
      } catch (error) {
        console.error("获取临时记录失败", error);
        ElMessage.error("获取临时记录失败");
      }
      this.updateAnswerDialog = false;
    },
    startExam() {
      if (this.isFirstVisit) {
        localStorage.setItem(`isFirstVisit-${this.examId}`, 'false');
      }
      this.$router.push('/examPage');
    },
  },
  mounted() {
    this.examId = this.joined_exam ? this.joined_exam.examid : -1;
    const storedUserInfo = localStorage.getItem('userInfo');
    if (this.isFirstVisit) {
      const interval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    }

    if (storedUserInfo) {
      this.userInfo = JSON.parse(storedUserInfo);
    }
  },
  computed: {
    ...mapGetters(['getJoinedExam']),
    joined_exam() {
      return this.getJoinedExam;
    },
    isFirstVisit() {
      return !localStorage.getItem(`isFirstVisit-${this.examId}`);
    }
  }
};
</script>
  
<style scoped>
.exam-rules-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.rules-card {
  max-width: 800px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.rules-list {
  text-align: left;
  font-size: 14px;
  line-height: 1.8;
  margin-bottom: 30px;
}

.button-container {
  margin-top: 20px;
}
</style>
